import type { TFunction } from '@wix/yoshi-flow-editor';
import type { ItemImage as Image } from '@wix/restaurants-populated-item-client/types';

const MEDIA_STORAGE_URL = 'https://static.wixstatic.com/media/';

export const getImageUrl = (
  image: Image,
  targetWidth: number,
  targetHeight: number,
  mode: 'fill' | 'fit' = 'fill',
): string =>
  `${MEDIA_STORAGE_URL}${image.id}/v1/${mode}/w_${targetWidth},h_${targetHeight},al_c,q_80,usm_0.66_1.00_0.01,enc_auto/${image.id}`;

export const getAltText = ({
  itemName = '',
  t,
}: {
  itemName?: string;
  t: TFunction;
}) => {
  return t('menu_olo.itemImage.altText', { dishName: itemName });
};
